import React from "react";
import './hero.css';

export default function Hero() {
    return (
        <section className="hero">
            <div className="hero-content">
                <div className="hero-eyebrow">
                    <span className="hero-eyebrow-dot" />
                    <span>Hair Artist &middot; Westerly, Rhode Island</span>
                </div>

                <h1 className="hero-title">
                    Katheryne<br />
                    <em>Ryan</em>
                </h1>

                <div className="hero-divider" />

                <p className="hero-description">
                    A passionate hairstylist based in Westerly, Rhode Island. I specialize in expert hair color services and personalized hair care. I believe that great hair starts with great care. My goal is to help you love your hair—not just when you leave the salon, but every day after.
                </p>

                <div className="hero-cta">
                    <a
                        href="https://www.vagaro.com/hairbykatheryne"
                        target="_blank"
                        rel="noreferrer"
                        className="hero-button"
                    >
                        Book an Appointment
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                </div>

                <div className="certifications">
                    <p className="certifications-label">Certified In</p>
                    <div className="certification-logos">
                        <img src="/k18.png"        alt="K18"       className="certification-logo" />
                        <img src="/olaplex.png"    alt="Olaplex"   className="certification-logo" />
                        <img src="/amika.png"      alt="Amika"     className="certification-logo" />
                        <img src="/barbicide.png"  alt="Barbicide" className="certification-logo" />
                        <img src="/keratin.png"    alt="Keratin"   className="certification-logo" />
                        <img src="/redken.png"     alt="Redken"    className="certification-logo" />
                    </div>
                </div>
            </div>

            <div className="hero-img">
                <div className="hero-arch">
                    <img
                        src="/hero-img.webp"
                        alt="Katheryne Ryan"
                        className="hero-image"
                    />
                </div>
            </div>
        </section>
    );
}
